// import external dependencies
import 'jquery';
import 'jquery-visible/jquery.visible.min'
import 'slick-carousel/slick/slick.min'
import '@fortawesome/fontawesome-free'

// Import everything from autoload
import "./autoload/_bootstrap.js"

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import templateHome from './routes/home';
import templateAboutUs from './routes/about';
import postTypeArchiveCases from './routes/cases';
import singleCases from './routes/single-cases';
import templateTeam from './routes/team';
import templateJoinus from './routes/joinus';
import singleBlogrs from './routes/single-blog';
import postTypeArchiveBlogrs from './routes/blog';
import templateContact from './routes/contact';
import templateOffer from './routes/offer';
import postTypeArchiveServicios from './routes/services';
import templateCustomLanding from './routes/custom-landing';
import templateHomeNew from './routes/home-new';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  templateHome,
  // About Us page, note the change from about-us to aboutUs.
  templateAboutUs,
  postTypeArchiveCases,
  singleCases,
  templateTeam,
  templateJoinus,
  singleBlogrs,
  postTypeArchiveBlogrs,
  templateContact,
  templateOffer,
  postTypeArchiveServicios,
  templateCustomLanding,
  templateHomeNew,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js